import getCanvas from '../helpers/getCanvas';

const labelToSelectOption = (html) => {
  const canvas = getCanvas(html);
  const form = canvas.querySelector('form');

  if (!form) {
    return html;
  }

  const selects = form.querySelectorAll('select');

  Array.from(selects).forEach((select) => {
    const selectId = select.getAttribute('id');
    const labels = form.querySelectorAll(`label[for="${selectId}"]`);
    const blankOptions = select.querySelectorAll('option[value=""]');

    Array.from(blankOptions).forEach((blankOption) => {
      blankOption.remove();
    });

    if (selectId && labels.length === 1) {
      const label = labels[0];
      const option = document.createElement('option');

      option.innerHTML = `-- ${label.textContent} --`;
      option.setAttribute('disabled', true);
      option.setAttribute('selected', true);

      select.insertBefore(option, select.firstChild);

      label.parentNode.removeChild(label);
    }
  });

  return canvas.innerHTML;
};

export default labelToSelectOption;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/factories/labelToSelectOption.js
 **/